import {
  findIndexMatchingCfiFallBackToBefore,
  getExtendedCfi,
} from "../../../../../../common/utils/cfi";
import TocNode from "./TocNode";

export interface SortedTocNode extends TocNode {
  levelChildren?: SortedTocNode[];
}

export const MAX_TOC_DEPTH = 5;
// 4 parents max, lower levels will be rolled up to limit horizontal expansion

export function sortToc(tocArray): SortedTocNode[] {
  let allUnits: SortedTocNode[] = [];

  tocArray?.forEach((tocItem) => {
    let targetList = allUnits;
    const depth = Math.min(tocItem.level, MAX_TOC_DEPTH);
    for (let i = 0; i < depth - 1; i++) {
      const targetNode = targetList[targetList.length - 1];
      if (!targetNode.levelChildren) {
        targetNode.levelChildren = [];
      }
      targetList = targetNode.levelChildren;
    }

    // Clone because we will be adding levelChildren and don't want to mutate
    // the input data
    targetList.push({ ...tocItem });
  });

  return allUnits;
}

// Takes a raw response array from getTOC
// Returns a single TOC Object with item UUID as keys
export function tocById(toc) {
  const flatTocData = {};
  const lastParents = Array(MAX_TOC_DEPTH).fill(null);
  if (toc) {
    const tocData = toc.map((item) => {
      return Object.assign({ ...item });
    });
    tocData.forEach((item) => {
      let level = Math.min(item.level, MAX_TOC_DEPTH);
      flatTocData[item.uuid] = { parent: lastParents[level - 1] };
      lastParents[level] = item.uuid;
      for (let i = level + 1; i < MAX_TOC_DEPTH; i++) {
        lastParents[i] = null;
      }
    });
  }

  return flatTocData;
}

export function getChapterNodeForCFI(cfi, options): TocNode | undefined {
  options = options || {};
  let toc;
  if (options.chapters && options.chapters.length) {
    toc = options.chapters;
  } else if (options.toc && options.toc.length) {
    toc = options.toc;
  }

  if (!toc || toc.length === 0) {
    return undefined;
  } // TOC is not loaded yet or is empty, return undefined

  const matchedIndex = findIndexMatchingCfiFallBackToBefore(
    toc,
    (el) => getExtendedCfi(el.cfi),
    getExtendedCfi(cfi)
  );

  if (matchedIndex !== -1) {
    return toc[matchedIndex];
  }
}

export function getChapterTitleForCFI(cfi, options): string {
  const node = getChapterNodeForCFI(cfi, options);
  if (node) {
    return node.title;
  }
  return ""; // TOC is not loaded yet or is empty, return empty string
}
